import fetchService from 'common/actions/fetchService';
import busProviderId from '../selectors/userConfig/busProviderId';

export const GET_BUS_CONTROL_SETTINGS = 'BUS/GET_BUS_CONTROL_SETTINGS';

export default function getBusControlSettings() {
  return (dispatch, getState) => {
    const state = getState();
    const providerId = busProviderId(state);

    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetoperator/provider/getControlSettings',
          { providerId }
        )
      )
    ).then(({ result }) =>
      dispatch({
        type: GET_BUS_CONTROL_SETTINGS,
        payload: result.data,
      })
    );
  };
}
